export const projects = [
    {
        key: "1",
        name: "VideoStream Pro",
        image: require('./images/Youtube.png'), 
        url: "https://videostreampro.vercel.app/"  
    },
    {
        key: "1",
        name: "Elecar",
        image: require('./images/Elecar.png'), 
        url: "https://elecarr.vercel.app/"  
    },
    {
        key: "3",
        name: "Crypto Currency Tracker",
        image: require('./images/Crypto.png'), 
        url: "https://crypto-updt.netlify.app/"  
    },
    {
        key: "4",
        name: "Dashboard",
        image: require('./images/Dashboard.png'),
        url: "https://dash-boarddd.netlify.app/"     
    },
    {
        key: "5",
        name: "Real Eastate Landing Page",
        image: require('./images/Property.png'),
        url: "https://rent-a-property-kappa.vercel.app/"  
    },
    {
        key: "6",
        name: "Restaurant Website",
        image: require('./images/Restaurant.png'),
        url: "https://gerichtrestaurantt.netlify.app/"     
    },
    {
        key: "7",
        name: "Clothing Website Landing Page",
        image: require('./images/Cloth.png'),
        url: "https://customcloth.netlify.app"     
    },
    {
        key: "8",
        name: "Todo app",
        image: require('./images/Notes.png'),
        url: "https://dailygoals.netlify.app/"     
    },
    {
        key: "9",
        name: "Minimalists Website",
        image: require('./images/Minimalists.png'),
        url: "https://deeproop.github.io/clone-minimalists-website/"     
    }

]
